import List from "@/components/list";
import router from "@/router";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;
  const selectionChange = listeners["selectionChange"] || function () { };
  const download = listeners["download"] || function () { }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [];
    if (item.sendStatusStr == '已发送') {
      dealConf.push(["iconfont ic_download iconfont-adapt", "下载", () => download(item), "admissionNotice:classDownload"]);
    }
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>)
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "m80"),
    tableBaseProps("工作单位", "deptName", "m150"),
    tableBaseProps("单位及职务", "unitPosition", "m150"),
    tableBaseProps("发送状态", "sendStatusStr", "m80"),
    tableBaseProps("联络员", "liaisonName", "m80"),
    tableBaseProps("联络员手机号", "liaisonPhone", "m100"),
    tableBaseProps("联络员下载状态", "liaisonDownloadName", "m80"),
    tableBaseProps("联络员下载时间", "liaisonDownloadTimeStr", "m150"),
    tableBaseProps("学员下载状态", "downloadName", "m80"),
    tableBaseProps("学员下载时间", "studentDownloadTimeStr", "m150"),
    tableBaseProps("发送时间", "createDateStr", "m150"),
    {
      label: "操作",
      fixed: "right",
      width: "90",
      render: (vo) => <Deal vo={vo} />,
    },
  ]
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={selectionChange} />;
}

export default Table;